import Behaviour from "../../../ui/Behaviour";
export class Alt1GLOverlay extends Behaviour {
    constructor(session, renderFilter, program, vertexObjectId, overlayOptions) {
        super();
        this.session = session;
        this.renderFilter = renderFilter;
        this.program = program;
        this.vertexObjectId = vertexObjectId;
        this.overlayOptions = overlayOptions;
        this.overlayHandle = null;
    }
    begin() {
        if (!Alt1GLOverlay._pageunload_hook_created) {
            window.addEventListener("pagehide", () => {
                Alt1GLOverlay._active_overlays.forEach(overlay => overlay.stop());
            });
            Alt1GLOverlay._pageunload_hook_created = true;
        }
        Alt1GLOverlay._active_overlays.push(this);
        console.log(`Starting overlay ${Alt1GLOverlay._active_overlays.length++}`);
        this.overlayHandle = this.session.get().beginOverlay(this.renderFilter, this.program.get(), this.vertexObjectId.vertex_array, this.overlayOptions);
    }
    end() {
        Alt1GLOverlay._active_overlays.splice(Alt1GLOverlay._active_overlays.indexOf(this), 1);
        this.overlayHandle?.stop();
        this.overlayHandle = null;
    }
}
Alt1GLOverlay._active_overlays = [];
Alt1GLOverlay._pageunload_hook_created = false;
